<template>
	<div
		:aria-selected="selected"
		:class="[{
			selected: selected,
			focused: focused
		}]"
		class="menu-combobox-option-item"
		tabindex="1"
		@click.stop.prevent="onSelect"
		@keydown.space.prevent="onSelect"
	>
		<div class="menu-combobox-option-item-icon-wrapper">
			<t-timpex-icon
				v-show="selected"
				:class="[{
					selected: selected,
					focused: focused
				}]"
				icon="tick"
				type="bp"
				class="menu-combobox-option-item-icon"
			/>
		</div>
		<span
			:class="[{
				selected: selected,
				bold: bold,
				focused: focused
			}]"
			:style="itemStyle"
			class="menu-combobox-option-item-inner"
		>
			<slot>{{ value }}</slot>
		</span>
	</div>
</template>

<script>
import menuItemMixin from './menuItemMixin';
import menuOptionItemMixin from './menuOptionItemMixin';
import TTimpexIcon from '../timpex/icons/TTimpexIcon';
export default {
	name: 'TMenuComboboxOptionItem',
	components: { TTimpexIcon },
	mixins: [ menuItemMixin, menuOptionItemMixin ],
};
</script>

<style lang="scss" scoped>
@import '~@/components/evergreen/scss/colors';
@import '~@/components/evergreen/scss/text';
	.menu-combobox-option-item {
		@extend %font-families-ui;
		@extend %text-default;
		user-select: none;
		color: get-color($text, 'muted');
		margin-top: 0;
		cursor: pointer;
		outline: none;
		display: flex;
		box-sizing: border-box;
		align-items: center;
		&:hover {
			background-color: rgba(67, 90, 111, 0.04);
		}
		&.selected, &:active {
			background-color: rgba(16, 112, 202, 0.06);
		}
		&.focused, &:focus {
			background-color: rgba(16, 112, 202, 0.04);
		}
	}

	.menu-combobox-option-item-icon-wrapper {
		display: flex;
		justify-content: center;
		padding-left: 12px;
		padding-right: 8px;
		height: 14px;
		width: 14px;
		box-sizing: content-box;
	}

	.menu-combobox-option-item-icon {
		color: get-color($icon, 'default');
		margin-left: 0;
		margin-right: 0;
		height: 14px;
		width: 14px;
		box-sizing: border-box;
		&.selected {
			color: get-color($blue, 'base');
		}
		&.focused {
			color: get-color($blue, 'dark');
		}
	}

	.menu-combobox-option-item-inner {
		flex:1;
		display: flex;
		align-items: center;
		font-weight: 400;
		font-size: 12px;
		margin-left: 0;
		margin-right: 0;
		border-bottom: 1px solid rgb(237, 240, 242);
		box-sizing: border-box;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		&.selected {
			color: get-color($blue, 'base');
		}
		&.focused {
			color: get-color($blue, 'dark');
		}
		&.bold {
			font-weight: 500;
		}
	}
</style>
